import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from '@elevio/kb-kit/lib/App';
import config from './config';
import './css/main.css';
const target = document.getElementById('kb-target');
if (!target)
    throw new Error('Cant find target div');
if (!document.title.trim()) {
    document.title = 'CodeReport';
}
target.setAttribute('role', 'main');
target.setAttribute('aria-label', 'Knowledge base content');
const rootLandmarkObserver = new MutationObserver(() => {
    if (target.querySelector('main.page, main.main')) {
        target.removeAttribute('role');
        target.removeAttribute('aria-label');
        rootLandmarkObserver.disconnect();
    }
});
rootLandmarkObserver.observe(target, { childList: true, subtree: true });
ReactDOM.render(<App config={config}/>, target);
